export const ARTIFACT_HORIZONTAL_OFFSET = 80;
export const ARTIFACT_VERTICAL_STRIDE = 150;
